/** 部门 Id */
export type DeptId = string;
/** 部门编号 */
export type DeptNo = number;

export enum DeptType {
    /** 内部部门 */
    internal = 0,
    /** 互联组织部门 */
    corp_coop = 2
}
export enum DeptStatus {
    /** 已失效 */
    dismission = -1,
    /** 邀请中 */
    unjoined = 0,
    /** 已激活 */
    active = 1
}

export interface IDept {
    _id: DeptId;
    /** 部门名称 */
    name: string;
    dept_no: DeptNo;
    parent_no: DeptNo;
    /** 路径编号数组 */
    path: DeptNo[];
    /** 类型 */
    type: DeptType;
    /** 状态 */
    status: DeptStatus;
    /** 排序顺序 */
    seq?: number;
    /** 部门所属上级部门名称数组（搜索时显示） */
    label?: string[];
    /** 是否可管理 */
    editable?: boolean;
    /** 是否可查看 */
    readable?: boolean;
    /** 互联组织所属标签 */
    label_id_list?: string[];

    // 兼容结构（注释先保留下，兼容结构移除后删除）
    // departmentId: DeptNo; // dept_no
    // parentId: DeptNo; // parent_no
    // order?: number; // seq
}

/** 当前登录用户所在部门 */
export interface LoginUserDept {
    /** 部门 Id */
    _id: string;
    /** 部门名称 */
    name: string;
    /** 企业 Id */
    corpId: string;
    /** 部门编号 */
    departmentId: DeptNo;
    /** 父部门编号 */
    parentId: DeptNo;
    /** 祖先部门编号列表 */
    path: DeptNo[];
    /** 部门类型 */
    type: DeptType;
    /** 部门状态 */
    status: DeptStatus;
    /** 按 path 顺序排列的祖先部门名称 */
    label: string[];
    /** 排序序号 */
    order?: number;
    /** 创建时间 */
    create_time?: string;
    /** 更新时间 */
    update_time?: string;
    /** 部门标签 Id 列表 */
    label_id_list?: string[];
    /** 集成模式外部 Id */
    integrate_id?: string;
}

export interface DeptCardView extends IDept {
    dept_path: { name: string }[];
}
